import { EventBus } from '../helpers/EventBus';
import { AvailableSite } from '../models/AppModels';
import { appEnv } from '../config/env';
import { AjaxService } from './AjaxService';

type SiteChangedCallback = (siteid: string) => void;

export class SiteSwitcher {
  private currentSiteKey = appEnv.storageCurrentSiteKey;
  private ajaxService: AjaxService;
  private onSiteChange: SiteChangedCallback[] = [];


  constructor() {
    this.ajaxService = new AjaxService();
  }

  // Method to get the current site from localStorage
  public getCurrentSite(): string | null {
    const currentSite = window.localStorage.getItem(this.currentSiteKey);

    // If no site is set, fetch available sites and set the first one
    if (!currentSite) {
      const url = '/Site/AvailableSites';

      this.ajaxService.Get<any>(url, true).then((result) => {
        if (result?.ReturnData?.length > 0) {
          this.setSelectedSiteKey(result.ReturnData[0].SiteId);
        }
      });
    }
    return currentSite;
  }

  public getSelectedSiteKey(): string | null {
    return window.localStorage.getItem(this.currentSiteKey);
  }

  public setSelectedSiteKey(siteId: string) {
    if (siteId) {
      const currentSiteId = window.localStorage.getItem(this.currentSiteKey);
      if (currentSiteId === siteId) return;

      if (currentSiteId && currentSiteId !== siteId) {
        window.localStorage.removeItem("LastUrl");
      }

      window.localStorage.setItem(this.currentSiteKey, siteId);
      EventBus.getInstance().publish(EventBus.Event.OnSiteSelected, siteId);
    }
  }

  public async getAvailableSites() : Promise<Array<AvailableSite>> {
    const url = '/Site/AvailableSites';
    let sites: Array<AvailableSite> = [];

    const result = await this.ajaxService.Get<any>(url, true);

    if (result?.ReturnData?.length > 0) {
      sites = result.ReturnData.map((siteinfo: AvailableSite) => {
        return siteinfo;
      });
    }

    return sites;
  }

  // Method to set the initial site (if none is selected)
  public setInitialSite(): Promise<boolean> {
    const url = '/Site/AvailableSites';

    return new Promise((resolve, reject) => {
      this.ajaxService.Get<any>(url, true).then((result) => {
        if (result?.ReturnData?.length > 0) {
          this.setSelectedSiteKey(result.ReturnData[0].SiteId);
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((error) => {
        console.error('Error fetching initial site:', error);
        reject(`'Error fetching initial site:', ${error}`);
      });
    });
  }

  // Method to clear the current site from localStorage
  public clearCurrentSite(): void {
    window.localStorage.removeItem(this.currentSiteKey);
  }

  // Method to get the site preview URL (returns a promise)
  public getSitePreviewUrl(versionId: string): Promise<string> {
    const siteId = this.getCurrentSite();

    return new Promise((resolve, reject) => {
      if (!siteId) {
        reject('No current site set');
        return;
      }

      const url = `/SiteAdmin/GetPreviewUrl/${siteId}/${versionId}`;

      this.ajaxService.Get<any>(url, true).then((result) => {
        resolve(result);
      }).catch((error) => {
        console.error('Error getting site preview URL:', error);
        reject(error);
      });
    });
  }
}
